import { SET_AUTH, SET_ROLE } from '../Actions/AuthActions';

const initialState = {
    isAuthenticated: false,
    roleId: null
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_AUTH:
            return {
                ...state,
                isAuthenticated: action.payload,
            };
        case SET_ROLE:
            return {
                ...state,
                roleId: action.payload,
            };
        default:
            return state;
    }
};

export default authReducer;